import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { AuthSelectors, SessionSelectors } from '@store';
import { StatistikIgangvaerende } from '../../models/StatistikIgangvaerende';

@Component({
    selector: 'app-statistik-igangvaerende',
    template: `
        <app-statistik-igangvaerende-ui
            [laCards]="laCards$ | async"
            [kaCards]="kaCards$ | async"
            [saCards]="saCards$ | async"
            [igangvaerende]="igangvaerende$ | async"
            [periode]="periode$ | async"
            [user]="user$ | async"
            (periodeChange)="periodeChange($event)"
            (saChange)="saChange($event)"
            (reload)="reload()"
        ></app-statistik-igangvaerende-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikIgangvaerendeContainer {
    reloadSubject = new BehaviorSubject<void>(null);
    reload$ = this.reloadSubject.asObservable();
    periodeSubject = new Subject<string>();
    periode$ = this.periodeSubject.asObservable();
    saSubject = new BehaviorSubject<number>(0);
    sa$ = this.saSubject.asObservable();
    igangvaerende$: Observable<StatistikIgangvaerende[]> = combineLatest([
        this.statistikService.visible$,
        this.statistikService.step$,
        this.periode$,
        this.sa$,
        this.reload$
    ]).pipe(
        filter(([visible, step]) => visible && step === 4),
        switchMap(([, , date, sa]) => this.statistikService.getIgangvaerende(date, sa))
    );
    laCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersLA$(new Date(date))));
    kaCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersKA$(new Date(date))));
    saCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersSA$(new Date(date))));
    user$ = this.authSelector.user$;

    constructor(
        private statistikService: StatistikService,
        private sessionSelector: SessionSelectors,
        private authSelector: AuthSelectors,
    ) { }

    reload() {
        this.reloadSubject.next();
    }

    periodeChange(periode: string) {
        this.periodeSubject.next(periode);
    }

    saChange(sa: number) {
        this.saSubject.next(sa);
    }
}

